export var getId = function getId(id) {
  return "@@" + id;
};